import * as NavigationMenu from '@radix-ui/react-navigation-menu';
import { tk, withStyleModifiers } from '@sunwebgroup/ui-components';
import { styled } from 'styled-components';
import { HeaderLink } from '../HeaderLink';
import { MenuTrigger } from '../Menu/Trigger';
import type { PropsWithChildren } from 'react';

function Navbar({ children, ...props }: PropsWithChildren<NavigationMenu.NavigationMenuProps>) {
  return <NavigationMenu.Root {...props}>{children}</NavigationMenu.Root>;
}

const List = styled(NavigationMenu.List)`
  align-items: center;
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
`;

const Item = styled(NavigationMenu.Item)`
  & > ${HeaderLink}:hover {
    color: ${tk('color_semantic_text_primary')};
  }

  & > ${MenuTrigger} {
    border-radius: ${tk('radius_rounded')};
  }
`;

const Content = styled(NavigationMenu.Content)``;

const StyledNavbar = styled(Navbar)``;

export default withStyleModifiers(StyledNavbar, { List, Item, Content });
